/*
  Vanilla replacement for Foundation Reveal (modal).
  Supports the existing markup: .reveal[data-reveal][id], opened by [data-open="<id>"]
  and closed by [data-close], overlay click or Escape.

  Replaces the Foundation "open.zf.reveal"/"closed.zf.reveal" events with
  "reveal:open"/"reveal:closed" dispatched on the modal element.
*/

const OVERLAY_CLASS = "reveal-overlay";
const BODY_OPEN_CLASS = "is-reveal-open";

const overlayFor = (modal) => {
  if (modal.parentElement?.classList.contains(OVERLAY_CLASS)) {
    return modal.parentElement;
  }
  const overlay = document.createElement("div");
  overlay.className = OVERLAY_CLASS;
  modal.parentElement.insertBefore(overlay, modal);
  overlay.appendChild(modal);
  return overlay;
};

export const closeReveal = (modal) => {
  if (modal?.dataset.revealOpen !== "true") {
    return;
  }
  const overlay = overlayFor(modal);

  modal.dataset.revealOpen = "false";
  modal.style.display = "";
  modal.setAttribute("aria-hidden", "true");
  overlay.style.display = "";
  document.body.classList.remove(BODY_OPEN_CLASS);

  modal.dispatchEvent(new CustomEvent("reveal:closed", { bubbles: true }));
};

export const openReveal = (modal) => {
  if (!modal || modal.dataset.revealOpen === "true") {
    return;
  }
  const overlay = overlayFor(modal);

  modal.dataset.revealOpen = "true";
  overlay.style.display = "block";
  modal.style.display = "block";
  modal.setAttribute("aria-hidden", "false");
  document.body.classList.add(BODY_OPEN_CLASS);

  modal.dispatchEvent(new CustomEvent("reveal:open", { bubbles: true }));
  modal.focus?.();
};

const openModals = () =>
  Array.from(document.querySelectorAll('[data-reveal][data-reveal-open="true"]'));

export const revealInit = (scope = document) => {
  scope.querySelectorAll("[data-reveal]").forEach((modal) => {
    modal.setAttribute("aria-hidden", "true");
    overlayFor(modal).addEventListener("click", (event) => {
      if (event.target === event.currentTarget) {
        closeReveal(modal);
      }
    });
  });

  document.addEventListener("click", (event) => {
    const opener = event.target.closest("[data-open]");
    if (opener) {
      event.preventDefault();
      openReveal(document.getElementById(opener.dataset.open));
      return;
    }

    const closer = event.target.closest("[data-close]");
    if (closer) {
      event.preventDefault();
      closeReveal(closer.closest("[data-reveal]"));
    }
  });

  document.addEventListener("keydown", (event) => {
    if (event.key === "Escape") {
      openModals().forEach(closeReveal);
    }
  });
};

export default revealInit;
